import { useFetchGet } from '../../../composables/useFetch'
import { Ref, computed } from 'vue'
import { PageDto } from '../shared/Contracts'
import { Project, ProjectStatus, ProjectType } from './Contracts'
import { EntityType } from '../utilization/Contracts'

export type ProjectQuery = {
  page: number
  pageSize: number
  internal: boolean
  budgetFrom?: number
  budgetTo?: number
  entityType?: EntityType
  entityIds?: string[]
  statuses?: ProjectStatus[]
  types?: ProjectType[]
}

export default function useFetchProjects(query: Ref<ProjectQuery | undefined>) {
  const urlWithParams = computed(() => {
    if (!query.value) return undefined

    const queryParams = new URLSearchParams()
    for (const key in query.value) {
      const value = query.value[key as keyof ProjectQuery]
      if (value !== undefined) {
        queryParams.append(key, value.toString())
      }
    }

    return `/core/v1/projects?${queryParams.toString()}`
  })

  return useFetchGet<PageDto<Project>>(urlWithParams)
}
